import { Controller, useFormContext } from 'react-hook-form'

import { CurrencySelectorCurrencyFragment } from 'generated/resources/graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import ExchangeRateTooltip from 'modules/expenses/components/expenses/Form/ExchangeRateTooltip'
import CurrencySelector from 'modules/finance/components/CurrencySelector'

import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'reimbursableCurrency'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  currencies?: CurrencySelectorCurrencyFragment[]
  canCustomizeSettings: boolean
  exchangeRateEnabled: boolean
  loadingExchangeRate: boolean
}

const ReimbursableCurrencyField = ({
  currencies,
  canCustomizeSettings,
  isFieldReadOnly,
  exchangeRateEnabled,
  loadingExchangeRate,
}: Props) => {
  const { control, watch, getValues } = useFormContext()
  const groupId = getValues('group')?.id

  const { currency, reimbursableCurrency, effectiveOn } = watch()

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <CurrencySelector
          data-testid="reimbursable-currency-selector"
          label={i18n.t('expenses_v2.forms.fields.reimbursable_currency.label')}
          secondaryLabel={
            exchangeRateEnabled && (
              <ExchangeRateTooltip
                loading={loadingExchangeRate}
                baseCurrency={currency}
                targetCurrency={reimbursableCurrency}
                date={moment(effectiveOn).format('YYYY-MM-DD')}
                rate={getValues('exchangeRate')}
                canCustomizeSettings={canCustomizeSettings}
              />
            )
          }
          currencies={currencies}
          value={field.value}
          isDisabled={isFieldReadOnly || !!groupId}
          onChange={(value) => {
            field.onChange(value)
          }}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(ReimbursableCurrencyField, FIELD_NAME))
